import "./Card.scss";

interface CardProps {
  width?: number;
  style?: any;
}

const Card: React.FC<CardProps> = (props) => {
  const { children, width = "100%", style } = props;
  return (
    <div className="card" style={{ width, ...style }}>
      {children}
    </div>
  );
};

export default Card;
